// extracted by mini-css-extract-plugin
module.exports = {"back-to-top":"ea","backToTop":"ea"};